// extracted by mini-css-extract-plugin
export default {"loader":"Load_loader__dOqz5"};